import {
  DETAIL_LIST_GIFT_SIM_IPB,
  DETAIL_LIST_GIFT_SIM_IPB_ERROR,
  CLEAN_DETAIL_LIST_GIFT_SIM_IPB,
  CLEAN_DETAIL_LIST_GIFT_SIM_IPB_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  response: undefined,
  status: undefined,
  state: undefined,
};

export default function detailGiftSimIpbReducer(state = initialState, action) {
  switch (action.type) {
    case DETAIL_LIST_GIFT_SIM_IPB:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        response: action?.response || {},
        status: action?.status || null,
        state: 'success',
      };

    case DETAIL_LIST_GIFT_SIM_IPB_ERROR:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        response: action?.response || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_DETAIL_LIST_GIFT_SIM_IPB:
      return {
        ...state,
        loaded: false,
        method: undefined,
        response: action?.response || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_DETAIL_LIST_GIFT_SIM_IPB_ERROR:
      return {
        ...state,
        loaded: false,
        method: undefined,
        response: action?.response || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
